import { map } from "lodash";
import { IRelatorio, RelatorioRendimentos } from "../../../models/declaracao";
import TabelaBase, {
  CelulaTexto,
  CelulaValor,
  TabelaBaseHeader,
} from "../../util/tabelas/tabelaBase";
import CelulaCodigo from "./celulaCodigo";
import { useUsuario } from "../../../providers/usuarioProvider";

type Props = {
  relatorio: IRelatorio<RelatorioRendimentos>;
};

export default function Relatorio3ou4({ relatorio }: Props) {
  const { claims } = useUsuario();
  const header: TabelaBaseHeader[] = [
    {
      titulo: "Tipo de Rendimento",
      key: "c1",
      ordem: 1,
      align: "left",
    },
    {
      titulo: "CPF/CNPJ da Fonte Pagadora",
      key: "c2",
      ordem: 2,
      align: "left",
    },
    { titulo: "Nome da Fonte Pagadora", key: "c3", ordem: 3, align: "left" },
    { titulo: "Descrição", key: "c4", ordem: 4, align: "left" },
    { titulo: "Valor", key: "c5", ordem: 5, align: "right" },
  ];

  const rows = map(relatorio.valores, (linha) => ({
    c1: <CelulaTexto texto={linha.tipoDeRendimento} copyOnClick />,
    c2: <CelulaCodigo codigo={linha.cnpj} copyOnClick />,
    c3: <CelulaTexto texto={linha.razaoSocial} copyOnClick />,
    c4: <CelulaTexto texto={linha.descricao} copyOnClick />,
    c5: (
      <CelulaValor
        valor={linha.valor}
        copyOnClick
        secret={!!!claims?.stripeRole}
      />
    ),
  }));

  return <TabelaBase header={header} rows={rows} />;
}
